import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { VehicleType } from "../../domain/models/vehicle-type";
import { VehicleGroupRepository } from "../../repositories/vehicle-group.repository";

@Injectable({ providedIn: 'root' })
export class GetVehicleTypesUsecase implements UseCase<null, VehicleType[]> {

  constructor(private readonly vehicleRepository: VehicleGroupRepository) {
  }

  execute(): Observable<VehicleType[]> {
    return this.vehicleRepository.getVehicleTypes();
  }

}
